import React from 'react'
import Left_menu from './Left_menu'
import Header from './Header'
import { useNavigate } from 'react-router-dom';
import { Container, Row, Col, Form, Button, ProgressBar, ModalHeader, ModalTitle } from "react-bootstrap";
// import './customer_style.css';
import Modal from 'react-bootstrap/Modal';
import { Tooltip as ReactTooltip } from "react-tooltip";
import axios from "axios";
import Swal from 'sweetalert2'
import { useLocation } from 'react-router-dom';
import ReactLoading from 'react-loading';
import config from "../../config"
import moment from 'react-moment';
import download from 'downloadjs'
import TablePagination from '@mui/material/TablePagination';
import { useNetworkState } from 'react-use';
import UseProgressTracker from './UseProgressTracker'
import Footer from './Footer'
import UseBulkShipmentTracker from './UseBulkShipmentTracker';
const Customer_orders = () => {
    let navigate = useNavigate()
    const isOnline = useNetworkState();
    console.log("isONline  === " ,isOnline )
    let userDetail = localStorage.getItem('ship_rocket_user');
    // console.log("userDetail====", config.UserId);
    let userData = {};
    if (userDetail != null) {
      userData = JSON.parse(userDetail)
    }
    const{showorderBar, completedOrdersbulk, totalOrdersbulk, logidstate, statusstateorder, toggleProgressBarbulk}= UseBulkShipmentTracker();
    const[userstate , setUserState] = React.useState({})
    const { showProgressBar, completedOrders, totalOrders, recordId, status, toggleProgressBar } = UseProgressTracker();

    const[recordid,setRecordid] = React.useState({record_id:""})
    const [uploadModalState, setUploadModalState] = React.useState({ show: false,excel_fle:"" });
    const[dimensionState,setdimensionState] = React.useState({companyDetail:[]})
    const[state,setState]= React.useState({shipment_list:[],isLoading:true})
    const [shipmentstate, setshipStatus] = React.useState({ shipment_status: null });
    const [shipSelect, setShipSelect] = React.useState({ shipment_id: "",cancel_reason:"" });
    const [modalState, setModalState] = React.useState({ show: false });
    const [modaldtdtcState, setModaldtdcState] = React.useState({ show: false });
    const[dtdc , setdtdc] = React.useState();
    const[loadingstate , setLoadingstate] = React.useState(false)
    const[summarystate , setSummarystate] = React.useState(false)
    const[isLoading , setisLoading] =React.useState(true)
    const[syncLoading , setsyncLoading] =React.useState(false)
    const[selected , setSelected] = React.useState({select_count:0 , select_order_id:[]})
    const[searchstate,setsearchstate]= React.useState({search_shipment:""})
    
    const[productselect , setProductselect] = React.useState({product_id:"" , carrier_id:""})
    const [otherStates,setOtherState] = React.useState({dstatus:"",activePage:1,rowsPerPage:20,page:0,total_count:0,onload:true});
    // console.log("otherState ==== " , otherStates)
    // console.log("selected === " , selected)
    const[product , setproduct] = React.useState([]) 
    const[onSubmitButton , setonSubmit] = React.useState(false)
    const[date, setdate] = React.useState({date:""})
    const[paymentmode, setpaymentmode] = React.useState({cod:false,prepaid:false})


    const Toast = Swal.mixin({
      toast: true,
      position: 'bottom-end',
      showConfirmButton: false,
      timer: 5000
  })

    // console.log("shipmentState",shipmentstate)
    React.useEffect(() => {
  
        shipment_list(null,0,true)
        dimension_detail()
        user()
      }, [otherStates.rowsPerPage])
      React.useEffect(()=>{
        shipment_list(null,0,true)
      },[date.date , paymentmode , searchstate.search_shipment])
    
        // console.log("shipmentState",shipmentstate)
       
      const user=()=>{
        let dataToSend = {
    };
    
      // console.log("datatoSend",dataToSend)
      let url = config.apiUrl + '/user/find_customer_detail';
    //  console.log("headers =========> ", config.headers);
      axios.post(url, dataToSend, { headers: config.headers })
      .then((res) => {
        // console.log("res ===" , res.data.output)
        setUserState(res.data.output)
        let response  = res.data.ouptut
        // console.log("response ===" , response)
        //   const obscuredAadhar = obscureAadharNumber(res.data.ouptut.aadhaar_number);
        // console.log("obscuredAadhar == " , obscuredAadhar)
        // setAadharNumber(obscuredAadhar);
          })
          .catch((error) => {
              // console.log(error);
          });    
    }
    const shipment_list=(status,index=0,onLoad)=>{
        let dataToSend = {customer_id : userData.customer_id ,find:searchstate.search_shipment,  status:status, limit:otherStates.rowsPerPage,indexValue:index
    };
    if(date.date!=""){
      dataToSend.date = date.date
    }
   
    if (paymentmode.cod && !paymentmode.prepaid) {
      dataToSend.payment_mode = 'cod';
  } else if (!paymentmode.cod && paymentmode.prepaid) {
      dataToSend.payment_mode = 'prepaid';
  } else if (paymentmode.cod && paymentmode.prepaid) {
      dataToSend.payment_mode = 'both';
  }
   
      // console.log("datatoSend",dataToSend)
      let url = config.apiUrl + '/shipment/customer_orders';
     
     // console.log("headers => ", config.headers);
     
      
      axios.post(url, dataToSend, { headers: config.headers })
          .then((res) => {
            // console.log("responseJson => ", res);
            if( onLoad) {
              setOtherState({...otherStates,total_count:res.data.count ,  page:index})         

  }
            setState({shipment_list:res.data.output,isLoading:false})
            setisLoading(false)
         
          })
          .catch((error) => {
              //Hide Loader
            //   setLoadingstate({...loadingstate,loading:false})
              // console.log(error);
          });    

    }
    const handlePageChange = (event,newPage) =>{
      setOtherState({...otherStates,page:newPage})
      // console.log("newPage ", newPage);
      // getCountryList(newPage);
      shipment_list(shipmentstate.shipment_status,newPage,true)
  }
  const handleChangeRowsPerPage = (event , newPage) => {
      // console.log("event ", event.target.value);
      setOtherState({ ...otherStates, rowsPerPage: event.target.value })
       
  }

    const dimension_detail = () =>{
      let full_api = config.apiUrl + `/user/get_company_info_api`;
      let sendData = {};
    
      axios.post(full_api, sendData, { headers: config.headers }).then(res => {
        setdimensionState({...dimensionState,companyDetail:res.data.companyDetail});
        // console.log("rnmmmmm", res);
      }).catch((e) => {
        // toast.configure()
         //toast.error("Some thing went wrong")
        // console.log("----error:   ", e);
      })
    }

    // const shipmentFilter = (status) => {
    //   // console.log("action ", status);
    //   setshipStatus({ ...shipmentstate, shipment_status: status })
    //   shipment_list(status)
    // }

    // const cancelModal = (ship) =>{
    //   // console.log("----ship:   ", ship.shipment_id);
    //   setShipSelect({cancel_reason:"",shipment_id:ship.shipment_id});
    //   setModalState({ show: true })
     
    // }

//     const cancelShipment = () =>{
//       if(shipSelect.cancel_reason != ""){
//       let full_api = config.apiUrl + `/shipment/shipment_cancel`;
//       let sendData = {customer_id:userData.customer_id,shipment_id:shipSelect.shipment_id,cancel_reason:shipSelect.cancel_reason};
    
//       axios.post(full_api, sendData, { headers: config.headers }).then(res => {
//         Toast.fire({
//           background: "#10b93b",
//           type: 'success',
//           title: res.data.message,
//           color: "white"
//       });
//         if(res.data.status == "success"){

//                 setShipSelect({cancel_reason:"",shipment_id:""});
//                 setModalState({ show: false })
//                 shipment_list()
//         }
//         // console.log("rnmmmmm", res);
//       }).catch((e) => {
//         // toast.configure()
//          //toast.error("Some thing went wrong")
//         // console.log("----error:   ", e);
//       })
//     }else {
//       Toast.fire({
//         background: "#10b93b",
//         type: 'success',
//         title: "Enter Reason to Cancel.",
//         color: "white"
//     });
//     }
//     }

//     const inputHandleChange = (e) => {
//       const value = e.target.value;
//       const text = e.target.name;
//       setShipSelect({ ...shipSelect, [text]: value })
//     }
    
//    const shipping_label =(sub)=>{
//     // console.log("sub ==== " , sub)
//     if(sub.carrier_id=="1656377059"){
//     let config = {
//       method: 'get',
//       maxBodyLength: Infinity,
//       url: 'https://dtdcapi.shipsy.io/api/customer/integration/consignment/shippinglabel/stream?reference_number='+sub.carrier_tracking_number,
//       responseType: 'blob',
//       headers: { 
//         'Content-Type': 'application/pdf', 
//         'api-key': 'e96fb203eef06314303c1aa7ef8c0c'
//       }
//     };
    
//     axios.request(config)
//     .then((response) => {
//       // console.log((response.data));
//       download(response.data, 'dtdc.pdf')
      
//     })
//     .catch((error) => {
//       // console.log(error);
//     });
  
//   }
//    }

//    const csvinputEditHandleChange = (e) => {        
//     if (e.target.type == "file") {            
//         setUploadModalState({ ...uploadModalState, [e.target.name]: e.target.files });
//     } else {
//         setUploadModalState({ ...uploadModalState, [e.target.name]: e.target.value });
//     }
//   }
//   const uploadOrdersFile= () => {
//     setLoadingstate(true)
//     if (uploadModalState.excel_fle != undefined && uploadModalState.excel_fle != '') {
//        // var patt1 = /\.([0-9a-z]+)(?:[\?#]|$)/i;
//         let fileName = uploadModalState.excel_fle[0].name;
//        // console.log("fileName =======>                 ",fileName);
       
//        // console.log("file =======>                 ",fileName.match(/\.([0-9a-z]+)(?:[\?#]|$)/i)[0]);
//        // return 
//         if(fileName.match(/\.([0-9a-z]+)(?:[\?#]|$)/i)[0] == ".csv"){
//             let full_api = config.apiUrl + `/shipment/upload_bulk_orders`;
//      let bodyFormData = new FormData()
//     // console.log("bb", editState);
    
//      bodyFormData.append("customer_id",  userData.customer_id)
    

    
//     bodyFormData.append("excel_fle", uploadModalState.excel_fle[0]);
     
//    // let bodyData = {country_id:country_id,csvFile:uploadModalState.csv_fle}
//     // console.log("bb", bodyFormData);
//     axios.post(full_api, bodyFormData, {
//         headers:config.headers
//     }).then((res) => {
//         // console.log("res ", res);

//         // setUploadModalState({...uploadModalState, show: false });
//       //  setEditState({ ...editState, state_name: "", state_id: "" })

       
//         if (res.status == 200 && res.data.status == "success") {
//           setLoadingstate(false)
//           setSummarystate(true)
//            setRecordid({record_id:res.data.record_id})
//            // setTimeout(getStateList(0,true), 5000);
//            const Toast = Swal.mixin({
//             toast: true,
//             position: 'bottom-end',
//             showConfirmButton: false,
//             timer: 3000
//         })
//             Toast.fire({
//                 background: "#206bc4",
//                 type: 'success',
//                 title: "Successfully Inserted",
//                 color: "white"
//             });
//             // shipment_list()
//             // setTimeout(()=>{
//             //   navigate(`/import_process/${product_id}/${carrier_id}/${source_city_id}`)
//             // },1000)
            
//         }
        
//         else {
//             Swal.fire({
//                 icon: 'error',
//                 title: 'Oops...',
//                 text: 'Something went wrong!',

//             })
//         }

//         // navigate('/categories')
//         // let newCategory = res.data.category;
//         //setState(state.concat([newCategory]))
//     }).catch((e) => {

//         Swal.fire({
//             icon: 'error',
//             title: 'Oops...',
//             text: 'Something went wrong!',

//         })
//     });
// }else {
//   const Toast = Swal.mixin({
//     toast: true,
//     position: 'bottom-end',
//     showConfirmButton: false,
//     timer: 3000
// })
//     Toast.fire({
//         background: "#8a2be2",
//         type: 'error',
//         title: "Please choose CSV file!",
//         color: "white"
//     });
// }
// }else {
//   const Toast = Swal.mixin({
//     toast: true,
//     position: 'bottom-end',
//     showConfirmButton: false,
//     timer: 3000
// })
//          Toast.fire({
//                 background: "#10b93b",
//                 type: 'error',
//                 title: "Please choose a file!",
//                 color: "white"
//             });
// }


// }
// const closeModal =()=>{
//   setUploadModalState({...uploadModalState,show:false})
//   shipment_list()
// }

        const syncOrders = ()=>{
            setsyncLoading(true)
            let full_api = config.apiUrl + `/shipment/sync_orders`;
            let sendData = {customer_id:userData.customer_id};
        
            axios.post(full_api, sendData, { headers: config.headers }).then(res => {
            // console.log("rnmmmmm", res);
            if(res.data.status==true){
                setsyncLoading(false)
                shipment_list()

            }
            else{
                const Toast = Swal.mixin({
                    toast: true,
                    position: 'bottom-end',
                    showConfirmButton: false,
                    timer: 3000
                })
                         Toast.fire({
                                background: "#10b93b",
                                type: 'error',
                                title: "Something Went Wrong!",
                                color: "white"
                            });
            }
            }).catch((e) => {
            // console.log("----error:   ", e);
            const Toast = Swal.mixin({
                toast: true,
                position: 'bottom-end',
                showConfirmButton: false,
                timer: 3000
            })
                     Toast.fire({
                            background: "#10b93b",
                            type: 'error',
                            title: "Something Went Wrong!",
                            color: "white"
                        });
            })
        }

        const clone_order = (sub) => {
          // console.log("order_id")
        
              let dataToSend = { sender_name: sub.sender[0].name,
                                  sender_mobile: sub.sender[0].mobile,
                                  sender_email: sub.sender[0].email,
                                  sender_address: sub.sender[0].address,
                                  sender_city: sub.sender[0].city,
                                  sender_city_id: sub.sender[0].city_id,
                                  sender_state_name:sub.sender[0].state,
                                  sender_country_name: sub.sender[0].country,
                                  sender_country_code: sub.sender[0].country_code,
                                  sender_postal_code: sub.sender[0].pincode,
                                  receiver_name: sub.receiver[0].name,
                                  receiver_mobile: sub.receiver[0].mobile,
                                  receiver_email: sub.receiver[0].email,
                                  receiver_address: sub.receiver[0].address,
                                  receiver_city: sub.receiver[0].city,
                                  receiver_country_name: sub.receiver[0].country,
                                  receiver_country_code: sub.receiver[0].country_code,
                                  receiver_postal_code: sub.receiver[0].pincode,
                                  receiver_state_name:sub.receiver[0].state,
                                  receiver_state_id:sub.receiver[0].state_id,
                                  receiver_city_id:sub.receiver[0].city_id,
                                  return_name:sub.return[0].name,
                                  return_mobile: sub.return[0].mobile,
                                  return_email: sub.return[0].email,
                                  return_address: sub.return[0].address,
                                  return_city:sub.return[0].city,
                                  return_state_name:sub.return[0].state,
                                  return_country_name: sub.return[0].country,
                                  return_country_code: sub.return[0].country_code,
                                  return_postal_code: sub.return[0].pincode,
                                  payment_mode:sub.payment_mode,
                                  shipment_type:sub.type,
                                  cod_amount : sub.cod_amount,
                                  volumetric_weight:sub.volumetric_weight,
                                  total_weight: sub.total_weight,
                                  dead_weight: sub.dead_weight,
                                  length: sub.length, height: sub.height,
                                  width: sub.width,
                                  insurance_amount: sub.insurance_amount,
                                  type:sub.type,
                                  address_id : sub.address_id,
                                  order_id:"",
                                  order_date: "",
                                  mode: sub.mode,
                                  carrier_type:1,
                                  
                                  }
                    
                                  dataToSend.item_name = sub.items.map((i)=>(
                                  i.item_name
                                  ))   
                                  dataToSend.item_value = sub.items.map((i)=>(
      
                                  i.item_value
                                  ))      
                                  dataToSend.quantity = sub.items.map((i)=>(
      
                                  i.item_quantity
                                  ))                   
                                  
                                  dataToSend.customer_id = userData.customer_id;
                                  // console.log("datatoSend", dataToSend)
      
                                  let url = config.apiUrl + '/shipment/order_create';
      
                                  // setOtherState({ ...otherState, submit_button: false })
                                  axios.post(url, dataToSend, { headers: config.headers })
                                  .then((responseJson) => {
                                  // console.log("responseJson => ", responseJson.data.output);
                                  // setOtherState({ ...otherState, submit_button: true })
                                  if (responseJson.data.status == true) {
                                    shipment_list()
                                    const Toast = Swal.mixin({
                                      toast: true,
                                      position: 'bottom-end',
                                      showConfirmButton: false,
                                      timer: 3000
                                    })       
                                  Toast.fire({
                                  background:"rgb(25, 135, 84)",
                                  type: 'unsuccess',
                                  title: "Order created successfully.",
                                  color:"white"
                                  });
      
                                  }
                                  else{
                                      const Toast = Swal.mixin({
                                          toast: true,
                                          position: 'bottom-end',
                                          showConfirmButton: false,
                                          timer: 3000
                                        })       
                                      Toast.fire({
                                      background:"rgb(25, 135, 84)",
                                      type: 'unsuccess',
                                      title: "Something Went Wrong.",
                                      color:"white"
                                      }); 
                                  }
                                  })
      }
      const next_step = (sub)=>{
        
        if(sub.sender[0].name!=undefined && sub.sender[0].name!="" && sub.sender[0].address!=undefined && sub.sender[0].address!="" &&sub.sender[0].country!=undefined && sub.sender[0].country!="" && sub.sender[0].country_code!=undefined && sub.sender[0].country_code!="" && sub.sender[0].pincode!=undefined && sub.sender[0].pincode!="" && sub.sender[0].state!=undefined && sub.sender[0].state!="" && sub.sender[0].city!=undefined && sub.sender[0].city!="" && sub.address_id!=undefined && sub.address_id!="" && sub.sender[0].city_id!=undefined && sub.sender[0].city_id!="" && sub.sender[0].mobile!=undefined && sub.sender[0].mobile!="" && sub.sender[0].email!=undefined && sub.sender[0].email!="" && sub.receiver[0].name!=undefined && sub.receiver[0].name!="" && sub.receiver[0].email!=undefined && sub.receiver[0].email!="" && sub.receiver[0].mobile!=undefined && sub.receiver[0].mobile !="" && sub.receiver[0].address !=undefined && sub.receiver[0].address!="" && sub.receiver[0].country!=undefined && sub.receiver[0].country!="" && sub.receiver[0].country_code!=undefined && sub.receiver[0].country_code!="" && sub.receiver[0].pincode!=undefined && sub.receiver[0].pincode!="" && sub.receiver[0].city!=undefined && sub.receiver[0].city!="" && sub.receiver[0].state!=undefined && sub.receiver[0].state!="" && sub.return[0].name!=undefined && sub.return[0].name!="" && sub.return[0].email!=undefined && sub.return[0].email!="" && sub.return[0].mobile!=undefined && sub.return[0].mobile !="" && sub.return[0].address !=undefined && sub.return[0].address!="" && sub.return[0].country!=undefined && sub.return[0].country!="" && sub.return[0].country_code!=undefined && sub.return[0].country_code!="" && sub.return[0].pincode!=undefined && sub.return[0].pincode!="" && sub.return[0].city!=undefined && sub.return[0].city!="" && sub.return[0].state!=undefined && sub.return[0].state!=""  && sub.mode!=undefined && sub.mode !="" && sub.items.length >0 && sub.type!=undefined && sub.type!="" && sub.order_number!=undefined && sub.order_number!=""  && sub.total_weight!=undefined && sub.total_weight!="" && sub.height!=undefined && sub.height!="" && sub.width!=undefined && sub.width!="" && sub.length!=undefined && sub.length!="" && sub.cod_amount !=undefined  &&  sub.payment_mode!=undefined && sub.payment_mode!="" && sub.volumetric_weight!=undefined  ){
          if (sub.payment_mode == "cod" && sub.cod_amount!=undefined && sub.cod_amount <= 0) {
            const Toast = Swal.mixin({
              toast: true,
              position: 'bottom-end',
              showConfirmButton: false,
              timer: 3000
            });
            Toast.fire({
              background: "rgb(25, 135, 84)",
              type: 'unsuccess',
              title: "COD amount must be greater than 0.",
              color: "white"
            });
          }
          else{
            navigate({pathname:`/customer/package_list`,
            search: `sender_name=${sub.sender[0].name}&sender_address=${sub.sender[0].address}&sender_country=${sub.sender[0].country}&sender_country_code=${sub.sender[0].country_code}&sender_postal_code=${sub.sender[0].pincode}&sender_state_name=${sub.sender[0].state}&sender_city=${sub.sender[0].city}&sender_address_id=${sub.address_id}&sender_city_id=${sub.sender[0].city_id}&sender_mobile=${sub.sender[0].mobile}&sender_email=${sub.sender[0].email}&receiver_name=${sub.receiver[0].name}&receiver_email=${sub.receiver[0].email}&receiver_mobile=${sub.receiver[0].mobile}&receiver_address=${sub.receiver[0].address}&receiver_country=${sub.receiver[0].country}&receiver_country_code=${sub.receiver[0].country_code}&receiver_postal_code=${sub.receiver[0].pincode}&receiver_city=${sub.receiver[0].city}&receiver_state_name=${sub.receiver[0].state}&return_name=${sub.return[0].name}&return_email=${sub.return[0].email}&return_mobile=${sub.return[0].mobile}&return_address=${sub.return[0].address}&return_country=${sub.return[0].country}&return_country_code=${sub.return[0].country_code}&return_postal_code=${sub.return[0].pincode}&return_city=${sub.return[0].city}&return_state_name=${sub.return[0].state}&mode=${sub.mode}${sub.items.map((i)=>(`&items=${i.item_value},${i.item_name},${i.item_quantity}`))}&shipment_type=${sub.type}&insurance=${sub.insurance_amount}&order_id=${sub.order_number}&order_date=${sub.order_date}&weight=${sub.total_weight}&height=${sub.height}&width=${sub.width}&length=${sub.length}&cod_amount=${sub.cod_amount}&payment_mode=${sub.payment_mode}&store_id=${sub.store_id!=undefined?sub.store_id:""}&channel_name=${sub.channel_name!=undefined?sub.channel_name:""}&volumetric_weight=${sub.volumetric_weight}&receiver_city_id=${sub.receiver[0].city_id}&receiver_state_id=${sub.receiver[0].state_id}&channel_id=${sub.channel_id?sub.channel_id:""}&carrier_type=1`
          })
          }
          
        
    
    }
    else{
      const Toast = Swal.mixin({
        toast: true,
        position: 'bottom-end',
        showConfirmButton: false,
        timer: 3000
      })       
    Toast.fire({
    background:"rgb(25, 135, 84)",
    type: 'unsuccess',
    title: "Please Fill All The Details.",
    color:"white"
    }); 
    }
  
      }
      const convertToYYYYMMDD = (inputDate) => {
        const dateParts = inputDate.split(/[-/]/); // Split by / or -
        // return `${dateParts[0]}-${dateParts[1]}-${dateParts[2]}`;
        const date = new Date(inputDate);
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
      };
      const edit_order =(sub)=>{
        const itemsJson = JSON.stringify(sub.items);
  const encodedItems = encodeURIComponent(itemsJson);
  // console.log("encodedItems === " , encodedItems)

 
  const orderDate = sub.order_date // Example order_date
  // console.log("orderDate === " , orderDate)
  const formattedOrderDate = convertToYYYYMMDD(orderDate);
  // const formattedOrderDate = moment(orderDate, 'DD/MM/YYYY').format('YYYY-MM-DD');

        navigate({pathname:`/customer/create_order`,
        search: `value=${sub.mode=="Domestic"?0:1}&receiver_name=${sub.receiver[0].name}&receiver_email=${sub.receiver[0].email}&receiver_mobile=${sub.receiver[0].mobile}&receiver_address=${sub.receiver[0].address}&receiver_country=${sub.receiver[0].country}&receiver_country_code=${sub.receiver[0].country_code}&receiver_postal_code=${sub.receiver[0].pincode}&receiver_city=${sub.receiver[0].city}&receiver_state_name=${sub.receiver[0].state}&sender_name=${sub.sender[0].name}&sender_address=${sub.sender[0].address}&sender_country=${sub.sender[0].country}&sender_country_code=${sub.sender[0].country_code}&sender_postal_code=${sub.sender[0].pincode}&sender_state_name=${sub.sender[0].state}&sender_city=${sub.sender[0].city}&sender_address_id=${sub.address_id}&sender_city_id=${sub.sender[0].city_id}&sender_mobile=${sub.sender[0].mobile}&sender_email=${sub.sender[0].email}&return_name=${sub.return[0].name}&return_email=${sub.return[0].email}&return_mobile=${sub.return[0].mobile}&return_address=${sub.return[0].address}&return_country=${sub.return[0].country}&return_country_code=${sub.return[0].country_code}&return_postal_code=${sub.return[0].pincode}&return_city=${sub.return[0].city}&return_state_name=${sub.return[0].state}&mode=${sub.mode}&items=${encodedItems}&shipment_type=${sub.type}&insurance=${sub.insurance_amount}&order_id=${sub.order_number}&order_date=${formattedOrderDate}&weight=${sub.total_weight}&height=${sub.height}&width=${sub.width}&length=${sub.length}&cod_amount=${sub.cod_amount}&payment_mode=${sub.payment_mode}&store_id=${sub.store_id!=undefined?sub.store_id:""}&channel_name=${sub.channel_name!=undefined?sub.channel_name:""}&volumetric_weight=${sub.volumetric_weight}&dead_weight=${sub.dead_weight}&receiver_state_id=${sub.receiver[0].state_id}&receiver_city_id=${sub.receiver[0].city_id}`
      })
      }

      const handleChangeSelected =(e , sub)=>{
        setSelected(prevSelected => {
          if (prevSelected.select_order_id.includes(sub.order_number)) {
            // Remove the orderId if it's already in the selected list
            return {
              select_count: prevSelected.select_count - 1,
              select_order_id: prevSelected.select_order_id.filter(id => id !== sub.order_number)
            };
          } else {
            // Add the orderId if it's not in the selected list
            return {
              select_count: prevSelected.select_count + 1,
              select_order_id: [...prevSelected.select_order_id, sub.order_number]
            };
          }
        });
      }

      const product_list=()=>{
        let dataToSend = {
    };
    // console.log("datatoSend",dataToSend)
      let url = config.apiUrl + '/shipment/all_product_list';
     axios.post(url, dataToSend, { headers: config.headers })
          .then((res) => {
            // console.log("responseJson => ", res);
            setproduct(res.data.output)
         })
          .catch((error) => {
              // console.log(error);
          });    
          }

    const showModal =()=>{
      product_list()
      setModalState({show:true})

    }

    const onChangeProduct =(e)=>{
      // console.log("e == " , e)
      let values =   Object.assign({},e.target.value.split(',') )
      // console.log("first",values[0])
      let product_id = values[0]
      let carrier_id = values[1]
       setProductselect({...productselect, product_id:product_id , carrier_id:carrier_id})
    }

    const onsubmit =()=>{
      setonSubmit(true)
      let dataToSend = {
        order_id :selected.select_order_id , product_id:productselect.product_id , carrier_id:productselect.carrier_id
      };
      // console.log("datatoSend",dataToSend)
      if(productselect.product_id!="" && productselect.carrier_id !=""){
        let url = config.apiUrl + '/shipment/bulk_shipment_booking';
        axios.post(url, dataToSend, { headers: config.headers })
             .then((res) => {
              //  console.log("responseJson => ", res);
               if(res.data.status==true){
                setonSubmit(false)
                navigate(`/customer/bulk_orders_log/${res.data.log_id}`)
               }
               else{
                setonSubmit(false)
               }
              //  setproduct(res.data.output)
            })
             .catch((error) => {
                //  console.log(error);
                setonSubmit(false)

             }); 
      }
      else{
        const Toast = Swal.mixin({
          toast: true,
          position: 'bottom-end',
          showConfirmButton: false,
          timer: 3000
        })       
      Toast.fire({
      background:"rgb(25, 135, 84)",
      type: 'unsuccess',
      title: "Please Select Product Type.",
      color:"white"
      }); 
      }
      
    }

    const modalClose =()=>{
      setModalState({show:false})
      setProductselect({...productselect , product_id:"" , carrier_id:""})

    }

    const handleSelectAll = (event) => {
      const selectedIds = event.target.checked
        ? state.shipment_list.map(order => order.order_number)
        : [];
  
      setSelected({
        select_count: selectedIds.length,
        select_order_id: selectedIds,
      });
    };

    const cancelOrder=(sub)=>{
      let dataToSend = {
        order_id :sub.order_number
      };
      // console.log("datatoSend",dataToSend)
     
        let url = config.apiUrl + '/shipment/cancel_order';
        axios.post(url, dataToSend, { headers: config.headers })
             .then((res) => {
              //  console.log("responseJson => ", res);
               if(res.data.status==true){
                shipment_list(null,0,true)
                const Toast = Swal.mixin({
                  toast: true,
                  position: 'bottom-end',
                  showConfirmButton: false,
                  timer: 3000
                })       
              Toast.fire({
              background:"rgb(25, 135, 84)",
              type: 'unsuccess',
              title: "Order Cancelled",
              color:"white"
              }); 
               }
              //  setproduct(res.data.output)
            })
             .catch((error) => {
                //  console.log(error);
             }); 
    }
    const cancelBulkOrder=()=>{
      let dataToSend = {
        order_id :selected.select_order_id
      };
      // console.log("datatoSend",dataToSend)
     
        let url = config.apiUrl + '/shipment/cancel_bulk_order';
        axios.post(url, dataToSend, { headers: config.headers })
             .then((res) => {
              //  console.log("responseJson => ", res);
               if(res.data.status==true){
                shipment_list(null,0,true)
                // window.location.reload()
                const Toast = Swal.mixin({
                  toast: true,
                  position: 'bottom-end',
                  showConfirmButton: false,
                  timer: 3000
                })       
              Toast.fire({
              background:"rgb(25, 135, 84)",
              type: 'unsuccess',
              title: "Orders Cancelled",
              color:"white"
              }); 
              window.location.reload()
               }
              //  setproduct(res.data.output)
            })
             .catch((error) => {
                //  console.log(error);
             }); 
    }
    const truncateText = (text, maxLength) => {
      return text.length > maxLength ? text.slice(0, maxLength) + '...' : text;
    };
    const handlesearchShipment=(e)=>{
      setsearchstate({search_shipment:e.target.value})
     }

     const dateselect =(e)=>{
      setdate({date:e.target.value})
   }

   const modeChange =(e , value)=>{
   if(e.target.checked){
setpaymentmode({...paymentmode , [e.target.name]:true})
   }
   else{
     setpaymentmode({...paymentmode , [e.target.name]:false})
   }

   }
  return (
//     <div>
//  {/* <?php include 'left_menu.php';?> */}
//  <Left_menu value={2}/>

// <section class="home ">
//     {/* <?php include 'header.php';?>  */}
// <Header/>
// <Modal show={modalState.show} onHide={() => setModalState({ show: false })} size='lg'>
// <Modal.Header closeButton>
//                     <Modal.Title>
//                     <h6 class="modal-title">Bulk Shipment</h6>
//                     </Modal.Title>
//                 </Modal.Header>
//                 <Modal.Body >
//       <div class="modal-body">
//         <div class="card border-0 shadow-sm bg-warning mb-3">
//           <div class="card-body">
//             <div class="d-flex justify-content-between">
//                 <div class="p-3">
//                   <i class="material-icons-outlined">emoji_objects</i>
//                 </div>
//                 <div class="ps-2 ">
//                   <p>Please select the appropiate product type along with Carrier to process the bulk shipment operation. Please check the log for any error.</p>
//                 </div>
//             </div>
//           </div>
//         </div>

//         <label for="" class="form-label">Select Product Type:</label>
//         <select class="form-select" onChange={(e)=>onChangeProduct(e)}>
//           <option>Select Product Type:</option>
//           {product.map((sub)=>(
//          <option value={[sub.product_id , sub.carrier_id]}>{sub.product_name}  -  {sub.carrier_name}</option>
   
//           ))}
       
//         </select>
// {onSubmitButton==false?
//         <div class="d-grid mt-3">
//           <a  class="btn btn-primary btn-block" onClick={()=>onsubmit()}>Submit</a>
//         </div>
//         :""}

//         <hr/>
//         <div class="d-flex justify-content-between mt-3">
//           <div class="">
            
//           </div>
//           <div class="">
//             <button type="button" class="btn btn-danger btn-sm" data-bs-dismiss="modal" onClick={()=>modalClose()}>Close</button>
//           </div>
//         </div>

//       </div>
    
//                 </Modal.Body>
               
//             </Modal>


//     <section class="mb-3 pt-4">
//       <div class="container">
//         <div class="row mb-3">
//           <div class="col-12 col-md-3">
//             <div class="d-flex">
//                 <div class="">
//                     <h3>Orders</h3>
//                 </div>
//                 <div class="ps-2 ">
//                     <select class="form-select form-select-sm">
//                       <option>All</option>
//                       <option>Domestic</option>
//                       <option>International</option>
//                     </select>
//                 </div>
//             </div>
//           </div>
//           <div class="col-12 col-md">
//             <div class="input-group input-group-sm mb-3">
//                 <span class="input-group-text"><i class="material-icons-outlined">search</i></span>
//                 <input type="text" class="form-control" name="search_shipment" placeholder="Enter Order Number" onChange={(e)=>handlesearchShipment(e)}/>
//                 <button class="btn btn-outline-primary" onClick={(e)=>shipment_list(null,0,true)}>Search</button>
//               </div>
//           </div>
//           <div class="col-12 col-md-2 text-end">
//             <a onClick={()=>navigate({
//             pathname: '/customer/create_order_1',
//             search: `value=0`,
//           })} class="btn btn-primary btn-sm "><i class="fa fa-plus" aria-hidden="true"></i> Create New Order</a>
//           </div>
//           <div class="col-12 col-md-2 text-end">
//           <a onClick={()=>navigate({
//             pathname: '/customer/order_import',
            
//           })} class="btn btn-primary btn-sm "><i class="fa fa-plus" aria-hidden="true"></i> Bulk Order Import</a>
//           </div>
//           <div class="col-12 col-md-2 text-end">
//             {syncLoading?
//              <ReactLoading type={"spin"} color={"#0d6efd"} height={40} width={30} />:
//             <a onClick={()=>syncOrders()} class="btn btn-primary btn-sm "> Sync Order</a>
// }
//           </div>
          
//         </div> 
        
//         <div class="row">
//                 <div class="col-12 col-md">
//                   {selected.select_count==0?
//                     <div>
//                         <ul class="nav nav-pills">
//                             <li class="nav-item">
//                             <a class="nav-link active" href="#">New</a>
//                             </li>
//                             {/* <li class="nav-item">
//                             <a class="nav-link" href="#">Old</a>
//                             </li>
//                             <li class="nav-item">
//                             <a class="nav-link" href="#">All</a>
//                             </li> */}
//                         </ul>
//                     </div> 
//                     :
//                     <div>
//                         <a href="#" class="btn btn-outline-secondary btn-sm"><strong>{selected.select_count}</strong> Selected</a>
//                       {userstate.aadhar_kyc!=undefined && userstate.aadhar_kyc==true ?  <a class="btn btn-outline-secondary btn-sm" onClick={()=>showModal()} data-bs-toggle="modal" data-bs-target="#bulkship"><strong><i class="fa fa-plane" aria-hidden="true" ></i></strong> Ship</a>: <a class="btn btn-outline-secondary btn-sm" href='/customer/customer_kyc' ><strong></strong> Need Kyc First</a>}
//                          <a onClick={()=>cancelBulkOrder()} class="btn btn-outline-secondary btn-sm"><strong><i class="fa fa-ban" aria-hidden="true"></i></strong> Cancel</a>
//                     {/* <a href="#" class="btn btn-outline-secondary btn-sm"><strong><i class="fa fa-print" aria-hidden="true"></i></strong> Print Pickup List</a> */}
                        
//                     </div> 
// }

//                 </div>
//                 <div class="col-12 col-md-4 text-end">
//                     <small><a href="/customer/bulk_orders_logs" class="text-muted" style={{textDecoration:"none"}}><i class="fa fa-info-circle" aria-hidden="true"></i> Bulk Order Log</a></small>
//                 </div>
//             </div>
               
//           </div>
//     </section>


//     <section class="mb-3">
//       <div class="container">
//         <div class="table-responsive">
//         {isLoading? <div style={{ display: 'flex', justifyContent: 'center', marginLeft:"80px", alignItems: 'center',marginTop:"-200px", height: '100vh' }}>
//       <ReactLoading type={"spin"} color={"#0d6efd"} height={40} width={60} />
//     </div>:
//             <table class="table table_box">
//                 <thead  class="">
//                     <tr class="brd">
//                     <th style={{width: "5%"}}>
//                         <div class="form-check form-check-inline pt-2">
//                         <input class="form-check-input" type="checkbox" id="inlineCheckbox1" value="option1" onChange={handleSelectAll}/>
//                         </div>
//                     </th>
//                     <th>Order Details</th>
//                     <th>Customer details</th>
//                     <th>Package Details</th>
//                     <th>Payment Mode</th>
//                     {/* <th>Pickup Address</th> */}
//                     {/* <th>Status</th> */}
//                     <th style={{width: "12%"}}>Action</th>
//                 </tr>
//                 </thead>
//                 <tbody>
//                 {state.shipment_list.map((sub)=>(
//                     <tr class="brd">
//                         <td>
//                             <div class="form-check form-check-inline">
//                                 <input class="form-check-input" type="checkbox" id="inlineCheckbox1" checked={selected.select_order_id.includes(sub.order_number)} value="option1" onChange={(e)=>handleChangeSelected(e , sub)} />
//                             </div>
//                         </td>
//                         <td>
//                             <h5><a href={`/customer/order_detail/${sub.order_number}`} style={{textDecoration:"none"}}>{sub.order_number}</a></h5>
//                             <small>{(sub.order_date)}</small>
//                             <h6>
//                                 {/* <a href="#" data-bs-toggle="popover" data-bs-placement="top" data-bs-trigger="hover" data-bs-content="Samsung Mobile Cover . QTY: 1">View Product</a> */}
//                             </h6>
//                         </td>
//                         <td>
//                         {sub.receiver.map((item)=>(
//                         <td>
//                             <h4>{item.name}</h4>
//                             <h4>{sub.warehouse_id}</h4>
//                             <small>{truncateText(item.address,50)}</small>
//                             <h6>{item.city},{item.state}-{item.pincode}</h6>
//                         </td>
//                         ))}
//                         </td>
//                         <td>
//                             <h4>Dead wt. : {sub.dead_weight!=undefined?sub.dead_weight:""} kg</h4>
//                             <small>{sub.height!=undefined?sub.height:""} x {sub.width!=undefined?sub.width:""} x {sub.length!=undefined?sub.length:""} (cm)</small>
//                             <h6>Volumetric wt.:  {sub.volumetric_weight!=undefined?sub.volumetric_weight:""} Kg</h6>
//                         </td>
//                         <td>
//                             {/* <h4>₹ 2000.00</h4> */}
//                             <small><span class="badge rounded-pill bg-warning fw-400">{sub.payment_mode}</span></small>
//                         </td>
//                         {/* <td>
//                             <h6><a style={{textDecoration:"none"}} class="text-muted" data-bs-toggle="popover" data-bs-placement="top" data-bs-trigger="hover" data-bs-content="St.293, NY, USA - 300393"> {sub.sender.map((item)=>(
//                         <td>
//                             <h4>{item.address}</h4>
//                             <small>{item.city}</small>
//                             <h6>{item.state}</h6>
//                             <small>{item.pincode}</small>

//                         </td>
//                         ))}</a></h6>
//                         </td> */}
//                         {/* <td>
//                             <h2><span class="badge rounded-pill bg-success fw-400">New</span></h2>
//                         </td> */}
//                         <td>
//                             <div class="d-flex ">
//                                 <div class="">
//                                  {sub.shipment_id==""?   <a  class="btn btn-primary btn-sm" onClick={()=> next_step(sub)}>Ship Now</a>:""}
//                                 </div>
//                                 <div class="ps-2 ">
//                                     <div class="dropdown ">
//                                         <span type=""  data-bs-toggle="dropdown">
//                                         <i class="material-icons-outlined" style={{cursor:"pointer"}}>more_vert</i>
//                                         </span>
//                                         <ul class="dropdown-menu ">
//                                         <li><a class="dropdown-item" onClick={()=>edit_order(sub)}>Edit Order</a></li>
//                                         <li><a class="dropdown-item" style={{cursor:"pointer"}} onClick={(e)=>clone_order(sub)}>Clone Order</a></li>
//                                         <li><a class="dropdown-item text-danger" onClick={(e)=>cancelOrder(sub)} style={{cursor:"pointer"}}>Cancel Order</a></li>
//                                         </ul>
//                                     </div>
//                                 </div>
//                             </div>
//                         </td>
//                     </tr>
//                 ))}
//                 </tbody>
                
//             </table>
// }
//         </div>     
//       </div>
//     </section>
//     <TablePagination
//                 component="div"
//                 rowsPerPageOptions={[5,10,15,20,25,50]}
//                 count={otherStates.total_count}
//                 page={otherStates.page}
//                 onPageChange={handlePageChange}
//                 rowsPerPage={otherStates.rowsPerPage}
//                 onRowsPerPageChange={handleChangeRowsPerPage}
               
//                         />
    
// </section>


// {/* <?php include 'footer.php';?> */}
//     </div>
<div>
<Left_menu value={2}/>

 <section class="home ">
     {/* <?php include 'header.php';?>  */}
 <Header/>
 <Modal show={modalState.show} onHide={() => setModalState({ show: false })} size='lg'>
<Modal.Header closeButton>
                    <Modal.Title>
                    <h6 class="modal-title">Bulk Shipment</h6>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body >
      <div class="modal-body">
        <div class="card border-0 shadow-sm bg-warning mb-3">
          <div class="card-body">
            <div class="d-flex justify-content-between">
                <div class="p-3">
                  <i class="material-icons-outlined">emoji_objects</i>
                </div>
                <div class="ps-2 ">
                  <p>Please select the appropiate product type along with Carrier to process the bulk shipment operation. Please check the log for any error.</p>
                </div>
            </div>
          </div>
        </div>

        <label for="" class="form-label">Select Product Type:</label>
        <select class="form-select" onChange={(e)=>onChangeProduct(e)}>
          <option>Select Product Type:</option>
          {product.map((sub)=>(
         <option value={[sub.product_id , sub.carrier_id]}>{sub.product_name}  -  {sub.carrier_name}</option>
   
          ))}
       
        </select>
{onSubmitButton==false?
        <div class="d-grid mt-3">
          <a  class="btn btn-primary btn-block" onClick={()=>onsubmit()}>Submit</a>
        </div>
        :""}

        <hr/>
        <div class="d-flex justify-content-between mt-3">
          <div class="">
            
          </div>
          <div class="">
            <button type="button" class="btn btn-danger btn-sm" data-bs-dismiss="modal" onClick={()=>modalClose()}>Close</button>
          </div>
        </div>

      </div>
    
                </Modal.Body>
               
            </Modal>
<section class="mb-3">
  <div class="container-fluid">
    <div class="row mb-3">
        <div class="col-12 col-md-4">
            <div class="d-flex">
              <a href="#" class="btn-back">
                <i class="bx bx-arrow-back"></i>
              </a>
              <h4>Orders</h4>
            </div>
        </div>
        <div class="col-12 col-md text-end">
          <div class="btn-group" role="group">
            <button id="btnGroupDrop1" type="button" class="btn btn-primary dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
              <i class="bx bx-plus"></i> Create Order
            </button>
            <ul class="dropdown-menu" aria-labelledby="btnGroupDrop1">
              <li><a class="dropdown-item" 
              onClick={()=>navigate({
            pathname: '/customer/create_order',
             search: `value=0`,
           })}
           ><i class="bx bx-plus"></i> Create Order</a></li>
              <li><a class="dropdown-item" onClick={()=>navigate({
             pathname: '/customer/order_import',
            
           })} ><i class="bx bx-upload"></i> Upload Bulk Orders</a></li>
           <li>
           {syncLoading?
              <ReactLoading type={"spin"} color={"#0d6efd"} height={40} width={30} />:
             <a onClick={()=>syncOrders()} class="dropdown-item">   <i class="bx bx-plus"></i>  Sync Order</a>
 }
           </li>
            </ul>
          </div>
        </div>
    </div>
    
    <div class="card mb-3 border-0 shadow-sm shipment_header_box">
      <div class="card-body">
        {/* <ul class="nav nav-pills">
          <li class="nav-item">
            <a class="nav-link active" href="#">All</a>
          </li>
          <li class="nav-item">
            <a class="nav-link" href="#">Domestic</a>
          </li>
          <li class="nav-item">
            <a class="nav-link" href="#">International</a>
          </li>
        </ul> */}
        {/* <div class="my-3">
          <div class="row">
              <div class="col-12 col-md">
                <label for="email" class="form-label">Search:</label>
                <input type="text" class="form-control form-control-sm" id="text" placeholder="Search by awb, order or shipment no"/>
              </div>
              <div class="col-12 col-md-2">
                <label for="email" class="form-label">From:</label>
                <input type="date" class="form-control form-control-sm" id="text" placeholder="Enter details nam"/>
              </div>
              <div class="col-12 col-md-2">
                <label for="email" class="form-label">To:</label>
                <input type="date" class="form-control form-control-sm" id="text" placeholder="Enter details nam"/>
              </div>
              <div class="col-12 col-md-2">
                <label for="email" class="form-label">Payment Mode:</label>
                <div>
                  <div class="form-check form-check-inline">
                    <input class="form-check-input" type="checkbox" id="inlineCheckbox1" value="option1"/>
                    <label class="form-check-label" for="inlineCheckbox1">Prepaid</label>
                  </div>
                  <div class="form-check form-check-inline">
                    <input class="form-check-input" type="checkbox" id="inlineCheckbox2" value="option2"/>
                    <label class="form-check-label" for="inlineCheckbox2">COD</label>
                  </div>
                </div>
              </div>
              <div class="col-12 col-md-2 text-end">
                <div class="mt-3">
                  <a href="#" class="btn btn-primary-oo btn-sm"><i class="bx bx-search"></i> Search</a>
                  <a href="#" class="btn btn-outline-primary-oo btn-sm">Reset</a>
                </div>
              </div>
          </div>
        </div> */}
         <div class="row my-3">
                <div class="col-12 col-md">
                    <div class="row">
                        <div class="col-12 col-md-5">
                            <div class="input-group input-group-sm mb-3">
                                {/* <select class="form-select">
                                    <option>Order ID</option>
                                    <option>Phone Number</option>
                                </select> */}
                                <input type="text" class="form-control" name="search_shipment" placeholder="Enter Order Number" onChange={(e)=>handlesearchShipment(e)}/>
                 {/* <button class="btn btn-primary" onClick={(e)=>shipment_list(null,0,true)}>Search</button> */}
                            </div>
                        </div>
                        <div class="col-12 col-md-3">
                            <input type="date" class="form-control form-control-sm" id="text" placeholder="Enter details name=" name="date" onChange={(e)=>dateselect(e)}/>
                        </div>
                      
                        <div class="col-12 col-md-2 filter_order">
                            <div class="dropdown">
                                <button type="button" class="btn btn-theme btn-sm dropdown-toggle" data-bs-toggle="dropdown">
                                    Payment Mode
                                </button>
                                <ul class="dropdown-menu">
                                    <li>
                                        <div class="form-check form-check-inline">
                                        <input class="form-check-input" type="checkbox" id="inlineCheckbox1" value="option1" name="cod" onChange={(e)=>modeChange(e)} checked={paymentmode.cod}/>
                                        <label class="form-check-label" for="inlineCheckbox1">Cash On Delivery</label>
                                        </div>
                                    </li>
                                    <li>
                                        <div class="form-check form-check-inline">
                                        <input class="form-check-input" type="checkbox" id="inlineCheckbox1" value="option1" name="prepaid" onChange={(e)=>modeChange(e)}  checked={paymentmode.prepaid}/>
                                        <label class="form-check-label" for="inlineCheckbox1">Prepaid</label>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
      </div>
    </div>

    <div class="card mb-3 border-0 shadow-sm ">
      <div class="card-body">
     
        <div class="table-responsive">
        {selected.select_count==0?"":
          <div class="shipment_head_actions mb-2">
            <ul class="nav nav-pills">
              <li class="nav-item">
                <a class="nav-link" href="#">{selected.select_count} Selected</a>
              </li>
              <li class="nav-item">
              {userstate.aadhar_kyc!=undefined && userstate.aadhar_kyc==true ?    <a class="nav-link" style={{cursor:"pointer"}} onClick={()=>showModal()} >Ship</a>:<a class="btn btn-outline-secondary btn-sm" href='/customer/customer_kyc' ><strong></strong> Need Kyc First</a>}
              </li>
              {/* <li class="nav-item">
                <a class="nav-link" href="#">Print Invoice</a>
              </li> */}
              <li class="nav-item">
                <a class="nav-link" style={{cursor:"pointer"}} onClick={()=>cancelBulkOrder()}>Cancel</a>
              </li>
            </ul>
          </div>
}
          <table class="table ">
              <thead class="table-light">
                <tr>
                  <th><input class="form-check-input" type="checkbox" id="inlineCheckbox1" value="option1" onChange={handleSelectAll}/></th>
                  <th style={{minWidth:"150px"}}>Order Details</th>
                  <th style={{minWidth:"180px"}}>Package Details</th>
                  <th style={{minWidth:"180px"}}>Product Details</th>
                  <th style={{minWidth:"300px"}}>Address Details</th>
                  <th style={{minWidth:"140px"}}>Payment Mode</th>
                  <th style={{minWidth:"140px"}}>Ship Now</th>
                  <th style={{minWidth:"120px"}}>Action</th>
                </tr>
              </thead>
              {state.shipment_list.map((sub)=>(
              <tbody>
                <tr>
                  <td>
                    <input class="form-check-input" type="checkbox" id="inlineCheckbox1" checked={selected.select_order_id.includes(sub.order_number)} value="option1" onChange={(e)=>handleChangeSelected(e , sub)}/>
                  </td>
                  <td>
                    <strong><a href={`/customer/order_detail/${sub.order_number}`} style={{textDecoration:"none"}}>{sub.order_number}</a></strong>
                    <p><small>{sub.order_date}</small></p>
                  </td>
                  <td>
                  <p>Dead wt. : {sub.dead_weight!=undefined?sub.dead_weight:""} kg</p>
                             <p>{sub.height!=undefined?sub.height:""} x {sub.width!=undefined?sub.width:""} x {sub.length!=undefined?sub.length:""} (cm)</p>
                             <p>Volumetric wt.:  {sub.volumetric_weight!=undefined?sub.volumetric_weight:""} Kg</p>
                            

                  
                  </td>
                  <td>
                    {sub.items.map((item)=>(
                      <>
                    <p>{item.item_name}</p>
                    <p>Qty:{item.item_quantity}</p>
                    </>
                    ))}
                  </td>
                  <td class="location_box_239">
                    <div class="timeline">
                      <div class="event">
                        <div class="date"><span class="text-danger l_icon"><i class="bx bx-map"></i></span>{sub.sender[0].city}-{sub.sender[0].pincode}</div>
                        <div class="details">{sub.warehouse_id?sub.warehouse_id:sub.warehouse_name}</div>
                      </div>
                      <div class="event">
                        <div class="date"><span class="text-success l_icon"><i class="bx bx-map"></i></span> {sub.receiver[0].city}-{sub.receiver[0].pincode}</div>
                        <div class="details">{sub.receiver[0].name} </div>
                        <div class="details">#{sub.receiver[0].address}, {sub.receiver[0].state}, {sub.receiver[0].city} - {sub.receiver[0].pincode}</div>
                      </div>
                    </div>
                  </td>
                  <td>
                    <span class="badge bg-primary">{sub.payment_mode}</span>
                    <p>{sub.payment_mode=="cod"?sub.cod_amount:""}</p>
                  </td>
                  <td>
                  {sub.shipment_id==""?   <a  class="btn btn-primary " style={{cursor:"pointer"}} onClick={()=> next_step(sub)}>Ship Now</a>:""}
                    {/* <a href="#" class="btn btn-primary" data-bs-toggle="modal" data-bs-target="#shipnow">Ship Now</a> */}
                  </td>
                  <td>
                 
                    <a style={{cursor:"pointer"}} class="btns_staus" data-bs-toggle="tooltip" onClick={()=>edit_order(sub)} title="Edit Order">
                      <i class="bx bx-edit"></i>
                    </a>
                    <a style={{cursor:"pointer"}} class="btns_staus" data-bs-toggle="tooltip" onClick={(e)=>clone_order(sub)} title="Clone Order">
                      <i class="bx bx-copy"></i>
                    </a>
                    <a style={{cursor:"pointer"}} class="btns_staus" data-bs-toggle="tooltip" onClick={(e)=>cancelOrder(sub)} title="Cancel Order">
                      <i class="bx bx-x"></i>
                    </a>
                  </td>
                </tr>
              </tbody>
              ))}
            </table>
        </div>
      </div>
    </div>

  </div>
</section>
<TablePagination
                component="div"
                rowsPerPageOptions={[5,10,15,20,25,50]}
                count={otherStates.total_count}
                page={otherStates.page}
                onPageChange={handlePageChange}
                rowsPerPage={otherStates.rowsPerPage}
                onRowsPerPageChange={handleChangeRowsPerPage}
               
                        />
    
</section>
<Footer
                    showProgressBar={showProgressBar}
                    completedOrders={completedOrders}
                    totalOrders={totalOrders}
                    viewLogs={recordId}
                    status ={status}
                     toggleProgressBar={toggleProgressBar} 
                     showorderBar={showorderBar}
                     completedOrdersbulk={completedOrdersbulk}
                     totalOrdersbulk={totalOrdersbulk}
                     viewLogslogid={logidstate}
                     statusbulk ={statusstateorder}
                      toggleProgressBarbulk={toggleProgressBarbulk} 
                  />

</div>



  )
}

export default Customer_orders
